import { ADD_IN_POPUP_LIST, REMOVE_POPUP_FROM_LIST } from '../actionTypes/popupActionTypes';
import createReducer from '../utils/createReducer';

const initialState = {
  popupList: []
};

const reducer = {
  [ADD_IN_POPUP_LIST]: (state, action) => {
    const { id } = action.payload;
    if (state.popupList.filter(popup => popup.id === id).length > 0) return state;
    return {
      ...state,
      popupList: [{ ...action.payload }, ...state.popupList]
    };
  },
  [REMOVE_POPUP_FROM_LIST]: (state, action) => {
    const { id } = action.payload;
    const updatedPopupList = state.popupList.filter(popup => popup.id !== id);
    return {
      ...state,
      popupList: updatedPopupList
    };
  }
};

export default createReducer(initialState, reducer);
